import type { IErrorResponse } from '../models/error-response.model';
import { IServiceBaseError } from '../services/service-base.service';

export class ErrorHandlerHelper {
  private static readonly nearByNotFoundAprErrorCode = 6008;
  private static readonly identicalOriginAndDestinationAprErrorCode = 2020;

  public static mapErrorToIErrorResponse(error: IServiceBaseError): IErrorResponse {
    return {
      statusCode: error?.httpStatusCode ?? 500, // Set default to 500 if no status code is available
      errorCode: error?.errorCode,
      errorLevel: undefined,
      errorMessage: undefined,
    };
  }

  public static isErrorResponse(obj: unknown): obj is IErrorResponse {
    if (typeof obj !== 'object' || obj === null) {
      return false;
    }
    const obj2 = obj as IErrorResponse;
    return obj2.statusCode !== undefined && typeof obj2.statusCode === 'number';
  }

  public static isAprErrorSignificant(error: unknown): boolean {
    if (!ErrorHandlerHelper.isErrorResponse(error) || error.statusCode !== 400) return true;

    // NV-8078
    switch (error.errorCode) {
      case ErrorHandlerHelper.nearByNotFoundAprErrorCode:
      case ErrorHandlerHelper.identicalOriginAndDestinationAprErrorCode:
        return false;
      default:
        return true;
    }
  }
}
